/* =============================================================
   WILD CUPPA — Shopify Theme JavaScript
   ============================================================= */

(function () {
  'use strict';

  /* ---- Header scroll behaviour ---- */
  const header = document.querySelector('.wc-header');
  if (header) {
    const onScroll = () => {
      header.classList.toggle('scrolled', window.scrollY > 40);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- Mobile navigation ---- */
  const hamburger = document.querySelector('.wc-header__hamburger');
  const mobileNav = document.querySelector('.wc-mobile-nav');
  const mobileOverlay = document.querySelector('.wc-mobile-nav__overlay');
  const mobileClose = document.querySelector('.wc-mobile-nav__close');

  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    mobileOverlay && mobileOverlay.classList.add('is-visible');
    hamburger && hamburger.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    mobileNav.setAttribute('aria-hidden', 'false');
  }

  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    mobileOverlay && mobileOverlay.classList.remove('is-visible');
    hamburger && hamburger.classList.remove('is-open');
    document.body.style.overflow = '';
    mobileNav.setAttribute('aria-hidden', 'true');
  }

  hamburger && hamburger.addEventListener('click', openMobileNav);
  mobileClose && mobileClose.addEventListener('click', closeMobileNav);
  mobileOverlay && mobileOverlay.addEventListener('click', closeMobileNav);

  /* ---- Scroll reveal ---- */
  const revealEls = document.querySelectorAll('.wc-reveal');
  if (revealEls.length > 0 && 'IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -60px 0px' }
    );
    revealEls.forEach((el) => revealObserver.observe(el));
  } else {
    revealEls.forEach((el) => el.classList.add('is-visible'));
  }

  /* ---- FAQ accordion ---- */
  const faqItems = document.querySelectorAll('.wc-faq__item');
  faqItems.forEach((item) => {
    const question = item.querySelector('.wc-faq__question');
    if (!question) return;
    question.addEventListener('click', () => {
      const isOpen = item.classList.contains('is-open');
      // Close all
      faqItems.forEach((i) => {
        i.classList.remove('is-open');
        const q = i.querySelector('.wc-faq__question');
        if (q) q.setAttribute('aria-expanded', 'false');
      });
      // Open clicked if it was closed
      if (!isOpen) {
        item.classList.add('is-open');
        question.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ---- Product page ---- */
  const productForm = document.getElementById('wc-product-form');
  if (productForm) {
    initProductPage();
  }

  function initProductPage() {
    // Thumbnail gallery
    const thumbs = document.querySelectorAll('.wc-product__thumb');
    const featuredImg = document.getElementById('wc-featured-img');
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        thumbs.forEach((t) => t.classList.remove('wc-product__thumb--active'));
        thumb.classList.add('wc-product__thumb--active');
        if (featuredImg && thumb.dataset.src) {
          featuredImg.style.opacity = '0';
          setTimeout(() => {
            featuredImg.src = thumb.dataset.src;
            featuredImg.style.opacity = '1';
          }, 200);
        }
      });
    });

    // Quantity buttons
    const qtyInput = document.getElementById('wc-qty-input');
    const qtyMinus = document.getElementById('wc-qty-minus');
    const qtyPlus = document.getElementById('wc-qty-plus');
    if (qtyInput) {
      qtyMinus && qtyMinus.addEventListener('click', () => {
        const v = parseInt(qtyInput.value, 10);
        if (v > 1) qtyInput.value = v - 1;
      });
      qtyPlus && qtyPlus.addEventListener('click', () => {
        qtyInput.value = parseInt(qtyInput.value, 10) + 1;
      });
    }

    // Variant selection
    const productJson = document.getElementById('wc-product-json');
    if (!productJson) return;
    let productData;
    try { productData = JSON.parse(productJson.textContent); } catch (e) { return; }
    const variants = productData.variants || [];

    // Colour swatches
    const swatches = document.querySelectorAll('.wc-product__swatch');
    const colourLabel = document.getElementById('wc-colour-label');
    swatches.forEach((swatch) => {
      swatch.addEventListener('click', () => {
        swatches.forEach((s) => s.classList.remove('wc-product__swatch--active'));
        swatch.classList.add('wc-product__swatch--active');
        if (colourLabel) colourLabel.textContent = '— ' + swatch.dataset.value;
        updateVariant();
      });
    });

    // Standard selects
    const selects = productForm.querySelectorAll('.wc-product__select');
    selects.forEach((sel) => sel.addEventListener('change', updateVariant));

    function getSelectedOptions() {
      const opts = [];
      const activeSwatch = document.querySelector('.wc-product__swatch--active');
      if (activeSwatch) opts.push(activeSwatch.dataset.value);
      selects.forEach((sel) => opts.push(sel.value));
      return opts;
    }

    function updateVariant() {
      const selected = getSelectedOptions();
      const variant = variants.find((v) => {
        const vOpts = [v.option1, v.option2, v.option3].filter(Boolean);
        return selected.every((o) => vOpts.includes(o));
      }) || variants[0];
      if (!variant) return;

      // Update hidden input
      const variantInput = document.getElementById('wc-variant-id');
      if (variantInput) variantInput.value = variant.id;

      // Update price
      const priceEl = document.getElementById('wc-price');
      if (priceEl) {
        const formatted = formatMoney(variant.price);
        priceEl.querySelector('.wc-product__price-current').textContent = formatted;
        const stickyPrice = document.getElementById('wc-sticky-price');
        if (stickyPrice) stickyPrice.textContent = formatted;
      }

      // Update ATC button
      const atcBtn = document.getElementById('wc-atc-btn');
      const atcText = document.getElementById('wc-atc-text');
      if (atcBtn) {
        if (variant.available) {
          atcBtn.disabled = false;
          if (atcText) atcText.textContent = 'Add to Bag — ' + formatMoney(variant.price);
        } else {
          atcBtn.disabled = true;
          atcBtn.innerHTML = '<span>Sold Out</span>';
        }
      }

      // Update featured image if variant has one
      if (variant.featured_image && featuredImg) {
        featuredImg.style.opacity = '0';
        setTimeout(() => {
          featuredImg.src = variant.featured_image;
          featuredImg.style.opacity = '1';
        }, 200);
      }
    }

    // Sticky ATC bar
    const stickyAtc = document.getElementById('wc-sticky-atc');
    const productInfo = document.getElementById('wc-product-info');
    const stickyBtn = document.getElementById('wc-sticky-btn');

    if (stickyAtc && productInfo) {
      const stickyObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            stickyAtc.classList.toggle('is-visible', !entry.isIntersecting);
            stickyAtc.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
          });
        },
        { threshold: 0 }
      );
      const atcWrap = productForm.querySelector('.wc-product__atc-wrap');
      if (atcWrap) stickyObserver.observe(atcWrap);
    }

    // Sticky ATC button triggers main form submit
    if (stickyBtn && productForm) {
      stickyBtn.addEventListener('click', () => {
        productForm.querySelector('[name="add"]').click();
      });
    }
  }

  /* ---- Cart quantity buttons ---- */
  document.querySelectorAll('.wc-cart-qty-minus, .wc-cart-qty-plus').forEach((btn) => {
    btn.addEventListener('click', () => {
      const line = btn.dataset.line;
      const row = btn.closest('.wc-cart-page__item');
      if (!row) return;
      const input = row.querySelector('input[name="updates[]"]');
      if (!input) return;
      let v = parseInt(input.value, 10);
      if (btn.classList.contains('wc-cart-qty-minus')) v = Math.max(0, v - 1);
      else v = v + 1;
      input.value = v;
    });
  });

  /* ---- Money formatter ---- */
  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    return '£' + amount.replace(/\.00$/, '');
  }

  /* ---- Announcement bar close ---- */
  const announcementClose = document.querySelector('.wc-announcement__close');
  const announcement = document.querySelector('.wc-announcement');
  if (announcementClose && announcement) {
    announcementClose.addEventListener('click', () => {
      announcement.style.height = announcement.offsetHeight + 'px';
      requestAnimationFrame(() => {
        announcement.style.transition = 'height 300ms ease, opacity 300ms ease';
        announcement.style.height = '0';
        announcement.style.opacity = '0';
        announcement.style.overflow = 'hidden';
      });
      try { sessionStorage.setItem('wc-announcement-closed', '1'); } catch (e) {}
    });
    try {
      if (sessionStorage.getItem('wc-announcement-closed')) {
        announcement.style.display = 'none';
      }
    } catch (e) {}
  }

})();
